import React from 'react';
import PropTypes from 'prop-types';

function Footnote(props) {
  const { data } = props;

  return (
    <article className="c-special-institutions">
      <div className="row">
        <div className="column small-12 medium-10 medium-offset-1">
          <h1 className="-light">What is the Resource Governance Index?</h1>
          {/* <h2 className="subtitle light"></h2> */}
        </div>
      </div>
      <div className="row">
        <div className="column small-12 medium-10 medium-offset-1">
          <p dangerouslySetInnerHTML={{ __html: data.footnote }}></p>
        </div>
      </div>
    </article>
  );
}

Footnote.propTypes = {
  data: PropTypes.object
};

export default Footnote;



// WEBPACK FOOTER //
// ./app/components/country-profiles/show/Footnote.jsx